<template>
  <!-- Login-free SOS entry point: /sos/<slug>/<token>/dispatcher. Resolves the SOS by its
       per-event share token, reads event.role, and renders the sender or receiver detail page —
       both standalone, addressed by the token. App.vue renders this component chromeless (see the
       .endsWith('/dispatcher') branch there). -->
  <div class="sos-dispatch-wrap">
    <div v-if="loading" class="sos-dispatch-state"><b-spinner small></b-spinner>&nbsp;Loading SOS&hellip;</div>
    <div v-else-if="error" class="sos-dispatch-state sos-dispatch-state--error">
      This SOS link isn't valid or has expired. Contact your dispatcher.
    </div>
    <sos-sender-detail v-else-if="role === 'sender'" :payload="payload" :token="token"/>
    <sos-receiver-detail v-else :payload="payload" :token="token"/>
  </div>
</template>

<script>
import { get_sos_detail_by_token } from '../networking/apis'
import SosSenderDetail from './sos_sender_detail.vue'
import SosReceiverDetail from './sos_receiver_detail.vue'

export default {
  name: 'sos_dispatch',
  components: { SosSenderDetail, SosReceiverDetail },
  data() {
    return {
      loading: true,
      error: false,
      payload: null,
      role: null,
    }
  },
  computed: {
    token() {
      return this.$route.params.token
    },
  },
  mounted() {
    this.load()
  },
  watch: {
    // the token can change without a remount if the app navigates between dispatcher links
    '$route'() {
      this.load()
    },
  },
  methods: {
    async load() {
      this.loading = true
      this.error = false
      try {
        const { value: { data = {} } } = await get_sos_detail_by_token(this.token)
        this.payload = data
        // role tells us which page this token belongs to: 'sender' (the source company) or
        // 'receiver' (a partner the broadcast reached). get_details returns it at the top level
        // (derived from source_request_id); fall back to event.role, then sender, for safety.
        this.role = data.role || (data.event && data.event.role) || 'sender'
      } catch (e) {
        this.error = true
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style scoped>
.sos-dispatch-wrap {
  min-height: 100vh;
}
.sos-dispatch-state {
  padding: 24px;
  text-align: center;
  color: #55636f;
  font-size: 14px;
}
.sos-dispatch-state--error {
  color: #b23b2e;
}
</style>
